import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-field-multi-select-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [class]="iconClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2"
        y="3.5"
        width="5"
        height="5"
        rx="1"
        stroke="#7C3AED"
        stroke-width="1.5" />
      <path
        d="M3.5 6L4.5 7L6.5 5"
        stroke="#7C3AED"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="9"
        y1="6"
        x2="18"
        y2="6"
        stroke="#7C3AED"
        stroke-width="1.5"
        stroke-linecap="round" />
      <rect
        x="2"
        y="11.5"
        width="5"
        height="5"
        rx="1"
        stroke="#7C3AED"
        stroke-width="1.5" />
      <path
        d="M3.5 14L4.5 15L6.5 13"
        stroke="#7C3AED"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="9"
        y1="14"
        x2="18"
        y2="14"
        stroke="#7C3AED"
        stroke-width="1.5"
        stroke-linecap="round" />
    </svg>
  `,
})
export class FieldMultiSelectIconComponent extends BaseIconComponent {}
